<template>
	<div class="auth logout">
		<h1>{{ $t('base.auth.logout') }}</h1>
		<p>{{ $t('base.auth.you_are_logged_out') }}</p>
		<router-link class="btn btn-primary" :to="{ name: 'AuthLogin' }">{{ $t('base.auth.login') }}</router-link>
		<span class="or">{{ $t('base.auth.or') }}</span>
		<router-link class="btn btn-primary" :to="{ name: 'AuthRegister' }">{{ $t('base.auth.logout') }}</router-link>
	</div>
</template>

<script>
import ServiceWorker from '@/sw'
export default {
	beforeCreate () {
		this.$title(this.$t('base.auth.logout'))
	},
	created () {
		//window.localStorage.clear()

		// TODO: disable notifications in where
		this.$store.dispatch('desactivePushToken', { context: this, token: ServiceWorker.pushToken })

		window.localStorage.removeItem('vuex')
		window.localStorage.removeItem('token')
		window.localStorage.removeItem('user')
		this.$store.dispatch('clearAll')
		this.$router.push({ name: 'HomePage' })
	}
}
</script>



// WEBPACK FOOTER //
// src/components/auth/AuthLogout.vue